export enum IncidentNibrsPropertyDescriptionType {
    DrugsNarcotics = '10',
    Automobiles = '03',
    Buses = '05',
    OtherMotorVehicles = '24',
    RecreationalVehicles = '28',
    Trucks = '37'
}